import React, { useState } from 'react';
import styles from './VideoPlayer.module.css';

interface VideoPlayerProps {
  videoUrl: string;
  title?: string;
  poster?: string;
  width?: string;
  height?: string;
  autoPlay?: boolean;
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
  videoUrl,
  title,
  poster,
  width = '100%',
  height = 'auto',
  autoPlay = false,
}) => {
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setHasError(true);
  };

  return (
    <div className={styles.videoContainer}>
      {hasError ? (
        <div className={styles.errorMessage}>
          <p>Sorry, the video could not be loaded. Please try again later.</p>
        </div>
      ) : (
        <div className={styles.playerWrapper}>
          <video
            className={styles.video}
            controls
            autoPlay={autoPlay}
            width={width}
            height={height}
            onError={handleError}
          >
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      )}
    </div>
  );
};
